import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactPlayer from 'react-player';
import classNames from 'classnames';
import PropTypes from 'prop-types';

class Player extends Component {

    state = {
        volume: 0,
        playing: false
    }

    setVolume = (volume, viewportHeight) => {
        const {bottom, top} = this
                .refs
                .player
                .wrapper
                .getBoundingClientRect(),
            height = bottom - top,
            half = height / 2,
            y = top + half,
            middle = viewportHeight / 2;
        if (top < middle && bottom > middle) {
            this.setState({
                playing: true,
                volume: volume * (
                    y >= middle
                        ? (middle - top) / half
                        : (bottom - middle) / half
                )
            });
        } else {
            this.setState({playing: false, volume: 0});
        }
    }

    updateVolume = () => {
        const {viewportHeight, volume} = this.props;
        this.setVolume(volume, viewportHeight);
    }

    onReady = () => {
        window.addEventListener('scroll', this.updateVolume);
        this.updateVolume();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.updateVolume);
    }

    componentWillReceiveProps({viewportHeight, volume}) {
        if (viewportHeight !== this.props.viewportHeight || volume !== this.props.volume) {
            this.setVolume(volume, viewportHeight);
        }
    }

    shouldComponentUpdate(props, {playing, volume}) {
        return playing !== this.state.playing || volume !== this.state.volume;
    }

    render() {
        const {className, url} = this.props, {playing, volume} = this.state;
        return <ReactPlayer
            className={classNames(className, 'Player')}
            ref="player"
            url={url}
            playing={playing}
            volume={volume}
            controls={true}
            loop={true}
            onReady={this.onReady}
            width='100%'
            height='100%'/>;
    }
}

Player.propTypes = {
    url: PropTypes
        .oneOfType([PropTypes.string, PropTypes.array])
        .isRequired,
    viewportHeight: PropTypes.number.isRequired,
    volume: PropTypes.number.isRequired
};

export default connect(({viewport: {
        height
    }, volume}) => ({viewportHeight: height, volume}))(Player);


// WEBPACK FOOTER //
// ./src/components/Player.js